import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function useGlobalLoading() {
  const responseLoading = useSelector((state) => state.response?.loading);
  const authorizationLoading = useSelector(
    (state) => state.authorization?.loading,
  );
  const transferLoading = useSelector((state) => state.transferResponse?.loading);
  const transferPopupVisible = useSelector(
    (state) =>
      Boolean(state.transferResponse?.isPopup) &&
      Boolean(state.advancePayrollConfirm?.isOpenSuccessModal),
  );
  const authorizationQrVisible = useSelector(
    (state) => Boolean(state.authorization?.qrData),
  );

  return useMemo(
    () =>
      !transferPopupVisible &&
      !authorizationQrVisible &&
      (responseLoading === "pending" ||
        responseLoading === "globalPending" ||
        authorizationLoading === "pending" ||
        transferLoading === "pending" ||
        transferLoading === "globalPending"),
    [
      responseLoading,
      authorizationLoading,
      authorizationQrVisible,
      transferLoading,
      transferPopupVisible,
    ],
  );
}
